import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import "./App.css";
import "./leaderboard.css";
import abi from "./utils/MotherYeast.json";
import motherdough from "./assets/motherdough.png";
import logo1 from "./assets/logo1.png";

const App = () => {
  const [currentAccount, setCurrentAccount] = useState("");
  const [count, setFeedCount] = useState("");
  // State property to hold leaderboard
  const [leaderboard, setLeaderboard] = useState([]);
  const [isMiningBlock, setIsMiningBlock] = useState(false);
  //This is what is updated after each new deployment of Yeasty.sol
  const contractAddress = "0x516E3dd217C2dc5C6A309f3f7301a88A5981209e";
  const contractABI = abi.abi;

  const checkIfWalletIsConnected = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        console.log("Make sure you have metamask!");
        return;
      } else {
        console.log("We have the eth object", ethereum);
      }

      const accounts = await ethereum.request({ method: "eth_accounts" });

      if (accounts.length !== 0) {
        const account = accounts[0];
        console.log("Found an authorized account: ", account);
        setCurrentAccount(account);
        checkFeedCountLeaderboard();
      } else {
        console.log("No authorized account found");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkFeedCountLeaderboard = async () => {
    try {
      const { ethereum } = window;
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const yeastContract = new ethers.Contract(
          contractAddress,
          contractABI,
          signer
        );
        var count = await yeastContract.getYeastCount();
        // console.log("what", count.toNumber());
        setFeedCount(count.toNumber());
        var leaderboard = await yeastContract.getLeaderboard();
        console.log("LEADERBOARD --> ", leaderboard);
        setLeaderboard(leaderboard);
      }
    } catch (error) {
      console.log("Actual error");
      console.log(error);
    }
  };

  const connectWallet = async () => {
    try {
      const { ethereum } = window;
      if (!ethereum) {
        alert("Get Metamask!");
        return;
      }
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      console.log("Connected", accounts);
      setCurrentAccount(accounts[0]);

      checkFeedCountLeaderboard();
    } catch (error) {
      console.log(error);
    }
  };

  const feed = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const yeastContract = new ethers.Contract(
          contractAddress,
          contractABI,
          signer
        );

        var count = await yeastContract.getYeastCount();
        setFeedCount(count.toNumber());
        console.log("Retrieved total yeast count: ", count.toNumber());

        // This part does the actual feeding
        const feedTxn = await yeastContract.addYeast();
        console.log("Mining...", feedTxn.hash);
        setIsMiningBlock(true);
        await feedTxn.wait();
        console.log("Mined -- ", feedTxn.hash);
        setIsMiningBlock(false);

        count = await yeastContract.getYeastCount();
        setFeedCount(count.toNumber());
        checkFeedCountLeaderboard();
        console.log("Retrieved total yeast count: ", count.toNumber());
      } else {
        console.log("Ethereum object doesn't exist.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkIfWalletIsConnected();
  }, []);

  return (
    <div className="mainContainer">
      <div className="dataContainer">
        <img src={logo1}></img>

        <div className="subtext">Please feed the mother dough.</div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "50px 0 0 0",
          }}
        >
          <img src={motherdough}></img>
        </div>

        {currentAccount && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "0 0 15px 0",
                fontSize: "28px",
                color: "#646464",
              }}
            >
              <a>
                <span
                  style={{ verticalAlign: "middle", padding: "0 20px 0 0" }}
                >
                  Feed Counter:
                </span>
                <span style={{ verticalAlign: "middle", fontSize: "72px" }}>
                  {count}
                </span>
              </a>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button className="feedButton" onClick={feed} disabled={isMiningBlock}>
                {!isMiningBlock ? "FEED ME" : "FEEDING..."}
              </button>
            </div>
          </div>
        )}

        {/* {isMiningBlock && (
          <div className="subtext">
            <p>Mining Block... </p>
          </div>
        )} */}

        {currentAccount && (
          <div>
            <p
              style={{
                position: "absolute",
                right: 5,
                top: 5,
                color: "#646464",
              }}
            >
              {currentAccount.slice(0, 7)}
            </p>
          </div>
        )}

        {/*
         * If there is no currentAccount render this button
         */}
        {!currentAccount && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button className="feedButton" onClick={connectWallet}>
              Connect to Metamask
            </button>
          </div>
        )}

        {currentAccount && (
          <div style={{ display: "flex", justifyContent: "center", padding: "100px" }}>
            <div className="leaderboard">
            <p className="subtext">Feeder Leaders</p>
              <table style={{minWidth: "360px"}}>
                <thead>
                  <tr>
                    {/* <th>Name</th> */}
                    <th>Wallet</th>
                    <th>Feedings</th>
                  </tr>
                </thead>
                <tbody>
                  {leaderboard.map((leaderboardItem, i) => (
                    leaderboardItem.score > 0 && <tr key={i}>
                      {/* <td>{leaderboardItem.id.toNumber()}</td> */}
                      <td>{leaderboardItem.username.substring(0,7) + ".." + leaderboardItem.username.substring(38, 42)}</td>
                      <td>{leaderboardItem.score.toNumber()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default App;
